import styled from 'styled-components';

export const ArticleGridSection = styled.div`
  display: grid;
  grid-template-columns: ${(props) =>
    props.stage ? '66% 28%' : '24% 44% 24%'};
  justify-content: space-between;
  margin-top: 24px;
  @media (max-width: 720px) {
    grid-template-columns: 100%;
    margin-top: 0;
  }
`;

export const ImageContainer = styled.div`
  display: flex;
  position: relative;
  width: 100%;
  margin: auto;
  margin-bottom: 1em;
  overflow: hidden;
  height: 0;
  padding-top: calc(688 / 1388 * 100%);
  background: url(https://images.myloapp.in/NestJsUploads/1668581912764-defaultimage.webp);

  @media (max-width: 720px) {
    height: 0;
    width: 100%;
    margin-bottom: 4px;
  }

  & img {
    position: absolute;
    top: 0;
    left: 0;
    z-index: 1;
    width: 100%;
    height: 100%;
  }

  .playIcon {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 69px;
    height: 46px;
    z-index: 9;
    border-radius: 12px;
    background: hsl(0deg, 0%, 0%, 60%);
    cursor: pointer;
    transition: all 0.2s ease;
    &:hover {
      background: hsl(0deg, 0%, 0%, 68%);
    }
    @media (max-width: 720px) {
      cursor: default;
      width: 62px;
      height: 39px;
    }

    img {
      width: 27px;
      height: 28px;
      position: absolute;
      left: 50%;
      top: 50%;
      transform: translate(-50%, -50%);

      @media (max-width: 720px) {
        width: 23px;
        height: 24px;
      }
    }
  }
`;
